import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { gridPageRequest, LinkedFile } from '../../../model/common/common.model';
import _ from 'lodash';
import { ConfirmationService, MessageService } from 'primeng/api';
import { LinkedFilesLookupComponent } from '../Linked-Files-lookup/linked-files.lookup.component';
import { SalesService } from '../../../services/sales.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-list-linked-files-lookup',
  standalone: true,
  imports: [SharedModule, CommonModule, AutoCompleteModule],
  templateUrl: './list-linked-files.lookup.component.html',
  styleUrl: './list-linked-files.lookup.component.scss',
  providers: [MessageService, ConfirmationService, DialogService]
})
export class ListLinkedFilesLookupComponent implements OnInit {
  fileTypes: any[]|undefined;
  isEdit: any;

  filteredProducts: any[] = [];
  listLinkedFile: LinkedFile[] = [];
  selected: LinkedFile[] = [];
  isDeleting: boolean = false;

  products: [] = [];
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 100,
    id: 0
  }

  filterProductList: any[] = [];
  saveData: any;
  submitted: boolean = false;
  orderId: any;
  loader: boolean | undefined;
  childRef: DynamicDialogRef | undefined;

  constructor(private salesService: SalesService, public ref: DynamicDialogRef, private messageService: MessageService, public dialogService: DialogService, private config: DynamicDialogConfig ,private confirmationService: ConfirmationService,private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    const orderId = this.config?.data?.orderNo;
    this.orderId = orderId;
    this.getLinkedFileList(this.orderId);
  }

  loadList(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getLinkedFileList(this.orderId);
  }

  getLinkedFileList(orderId: string) {
    this.loader = true;
    this.salesService.getLinkedFileOrderId(orderId).subscribe(
        (data: any) => {
          console.log(data);
            this.listLinkedFile = Array.isArray(data) ? data : [data];
            this.selected = [];
            this.loader = false;
            this.cdr.detectChanges();
        },
        (error: any) => {
            console.error(error);
            this.loader = false;
        }
    );
}



get safeListLinkedFile() {
  return Array.isArray(this.listLinkedFile) ? this.listLinkedFile : [];
}


  deleteLinkedFile() {
    if (this.isDeleting) return;
    this.isDeleting = true;
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        const linkedFileId = this.selected.map((file) => file.linkedId);
        this.salesService.deleteLinkedFile(linkedFileId).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Deleted successfully.'
            });

            setTimeout(() => {
              this.ref.close(true);
            }, 700);
          },
          error: (error) => {
            console.error(error);
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Deletion failed. Please try again.'
            });
          },
          complete: () => {
            this.isDeleting = false;
          }
        });
      },
      reject: () => {
        this.isDeleting = false;
      }
    });
  }


  cancel(data: any) {
    this.ref.close();
    this.selected = [];
  }


  openLinkedFiles(data?:any) {
    if (this.ref) {
      this.ref.close();
    }
    this.ref = this.dialogService.open(LinkedFilesLookupComponent, {
      header: `Linked File For Order ${this.orderId}`,
      width: '60%',
      data: { orderId: this.orderId }
    });
  }

  updateLinkedFile(data?:any) {
    if (this.ref) {
      this.ref.close();
    }
    this.ref = this.dialogService.open(LinkedFilesLookupComponent, {
      header: `Update Linked File For ${data.linkedId}`,
      width: '60%',
      data: { orderId: data.linkedId }
    });
  }

  viewDocument(linkFile: any) {
    if (!linkFile?.filePath) {
      console.error('Invalid file path');
      return;
    }

    const fileUrl = decodeURIComponent(linkFile.filePath);
    window.open(fileUrl, '_blank');
  }


}
